document.querySelectorAll(".btb-btn").forEach(function (btn) {
  btn.addEventListener("click", function () {
    const tabId = btn.getAttribute("data-tab");
    document.querySelectorAll(".btb-conti-container").forEach(function (container) {
      container.classList.remove("active");
    });
    const targetContainer = document.getElementById(tabId);
    if (targetContainer) {
      targetContainer.classList.add("active");
    }
    document.querySelectorAll(".btb-btn").forEach(function (otherBtn) {
      otherBtn.classList.remove("active");
    });
    btn.classList.add("active");
  });
});
